import ArchivosAdjuntosFileItem from "common/components/ArchivosAdjuntosFileItem"
import Dropzone from "common/components/Dropzone"
import Modal from "common/components/Modal/Modal"
import FacturaRecurrenteService from "common/services/FacturaRecurrenteService"
import FicheroService from "common/services/FicheroService"
import { TWENTY_MB } from "common/utils/constants"
import { removeMimeFromBase64, toBase64 } from "common/utils/formats"
import getFileTypeToTheBE from "common/utils/getFileTypeToTheBE"
import notification from "common/utils/notification"
import fileDownload from "js-file-download"
import { split } from "lodash"
import { nanoid } from "nanoid"
import { useCallback, useEffect, useState } from "react"

import i18next from "i18next"
import "./style.scss"

const ModalArchivosAdjuntos = ({
  show,
  setShow,
  facturaId,
  refresByIdFactura,
}: $TSMigrationFixMe) => {
  const [loading, setLoading] = useState(false)
  const [archivosAdjuntos, setArchivosAdjuntos] = useState([])

  const getInitialInfo = useCallback(async () => {
    if (facturaId) {
      const { data } = await FacturaRecurrenteService.getArchivosAdjuntosById(
        facturaId
      )
      setArchivosAdjuntos(data)
    }
  }, [facturaId])

  useEffect(() => {
    getInitialInfo()
  }, [getInitialInfo])

  const eliminarArchivoAdjunto = useCallback(
    async (fileID: $TSMigrationFixMe) => {
      setLoading(true)

      try {
        await FacturaRecurrenteService.deleteArchivoAdjunto(facturaId, fileID)
        refresByIdFactura()
        await getInitialInfo()
      } finally {
        setLoading(false)
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [facturaId]
  )

  const agregarArchivoAdjunto = useCallback(
    async (archivos: $TSMigrationFixMe) => {
      setLoading(true)

      try {
        const archivo = archivos[0]

        const extension = archivo.type.split("/")[1]
        await FacturaRecurrenteService.addNewArchivoAdjunto(facturaId, {
          esDocumentoImportado: true,
          extension,
          nombre: split(archivo.name, ".", 1)[0],
          tipo: getFileTypeToTheBE(archivo.name),
          // @ts-expect-error TS(2345): Argument of type 'unknown' is not assignable to pa...
          fileAsBase64: removeMimeFromBase64(await toBase64(archivo)),
        })
        refresByIdFactura()
        await getInitialInfo()
      } finally {
        setLoading(false)
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [facturaId, getInitialInfo]
  )

  const descargarArchivoAdjunto = useCallback(
    async (file: $TSMigrationFixMe) => {
      try {
        const { id, nombre, extension } = file
        const { data } = await FicheroService.descargarFichero(id)

        fileDownload(new Blob([data]), `${nombre}${extension}`)
      } catch (error) {
        notification.errorServidor({
          body: `${i18next.t("notification.downloadError")}`,
        })
      }
    },
    []
  )

  return (
    <Modal
      header='Archivos adjuntos'
      visible={show}
      onHide={() => setShow(false)}
      size='smallM'
    >
      <div className='factura-recurrente_detail-container modal-omitir_container'>
        <Dropzone
          loading={loading}
          maxSize={TWENTY_MB}
          onDrop={agregarArchivoAdjunto}
          accept='.pdf'
          acceptLabel='.pdf'
        />
        <div className='files-recurrentes_container'>
          {archivosAdjuntos.map((archivoAdjunto) => (
            <ArchivosAdjuntosFileItem
              key={nanoid()}
              // @ts-expect-error TS(2339): Property 'nombre' does not exist on type 'never'.
              name={archivoAdjunto.nombre}
              // @ts-expect-error TS(2339): Property 'tamañoEnBytes' does not exist on type 'n...
              size={archivoAdjunto.tamañoEnBytes}
              // @ts-expect-error TS(2339): Property 'id' does not exist on type 'never'.
              onDelete={() => eliminarArchivoAdjunto(archivoAdjunto.id)}
              onDownload={() => descargarArchivoAdjunto(archivoAdjunto)}
            />
          ))}
        </div>
      </div>
    </Modal>
  )
}

export default ModalArchivosAdjuntos
